import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CollapsibleCitation from './CollapsibleCitation';


const InformationPopUp = ({ 
    title = "Information",
    description="This is the static description. <br/>You can put any static text here. <br/>If the content is long, a scroll will appear in the dialog.",
    color="white",
    bg_color="bg-white",
    /* title_citation="title of the dataset",  */
    source="Source of the information",
    fullCitation="Full citation of the source. This can be a long text that will be collapsible.",
    color_citation="#fff" }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <IconButton sx={{ color: color }} onClick={handleOpen} aria-label="information">
                <InfoOutlinedIcon />
            </IconButton>
            <Dialog open={open} onClose={handleClose} aria-labelledby="info-dialog-title"
            PaperProps={{
                sx: {
                    backgroundImage: bg_color,
                    color: color_citation,
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    width: '600px',
                    height: 'auto',
                    overflowY: 'hidden',
                    borderRadius: 2,
                    boxShadow: 24
                }
            }}
            >
                <DialogTitle id="info-dialog-title">{title}</DialogTitle>
                <DialogContent
                    dividers
                    sx={{
                        maxHeight: 500,
                        
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            width: '8px',
                            background: 'transparent',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#ccc', // or any color you want for the thumb
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: 'transparent',
                        },
                        scrollbarColor: '#ccc transparent', // For Firefox
                        scrollbarWidth: 'thin', // For Firefox
                                    }}
                >
                    <Typography
                        component="span"
                        sx={{ whiteSpace: 'pre-line' }}
                        dangerouslySetInnerHTML={{
                            __html: description
                        }}
                    />
                    {source !== "Source of the information" ? <CollapsibleCitation
                        /* title_citation={title_citation} */
                        source={source}
                        fullCitation={fullCitation}
                        color={color_citation}
                    /> : null}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default InformationPopUp;